"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlumTreeRpcRemote = void 0;
const dht_1 = require("@streamr/dht");
class PlumTreeRpcRemote extends dht_1.RpcRemote {
    async sendMetadata(msg) {
        const options = this.formDhtRpcOptions({
            notification: true
        });
        await this.getClient().sendMetadata(msg, options);
    }
    async pauseNeighbor(messageChainId) {
        const options = this.formDhtRpcOptions({
            notification: true
        });
        await this.getClient().pauseNeighbor({ messageChainId }, options);
    }
    async resumeNeighbor(fromTimestamp, messageChainId) {
        const options = this.formDhtRpcOptions({
            notification: true
        });
        await this.getClient().resumeNeighbor({ fromTimestamp, messageChainId }, options);
    }
}
exports.PlumTreeRpcRemote = PlumTreeRpcRemote;
//# sourceMappingURL=PlumTreeRpcRemote.js.map